import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ShellService } from '@mynexus/mfe-core';
import { API_BASE_URL } from './service';

@NgModule({
    declarations: [],
    exports: [CommonModule], imports: [CommonModule], providers: [
        ShellService,
        {
            provide: API_BASE_URL,
            useFactory: (shellService: ShellService) => shellService.getBaseUrlFor('Platform'),
            deps: [ShellService]
        },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class CoreModule { }
